import React from "react";
import { cn } from "../../utils/cn";

export const Badge = ({
  value,
  children,
  severity = "primary",
  className,
  ...props
}) => {
  const severityStyles = {
    primary: "bg-urb-primary/10 text-urb-primary border-urb-primary/30",
    success: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    info: "bg-blue-500/10 text-blue-400 border-blue-500/30",
    warning: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    danger: "bg-red-500/10 text-red-400 border-red-500/30",
    neutral: "bg-slate-500/10 text-slate-300 border-slate-500/30",
  };

  const content = value !== undefined ? value : children;

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center px-2.5 py-0.5 text-xs font-semibold rounded-full border tracking-wide whitespace-nowrap",
        severityStyles[severity] || severityStyles.primary,
        className
      )}
      {...props}
    >
      {content}
    </span>
  );
};

export const Tag = Badge;
export default Badge;
